import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "my-header d-flex justify-content-between" }
const _hoisted_2 = { class: "fs-4" }
const _hoisted_3 = { class: "table table-tenant" }
const _hoisted_4 = {
  key: 0,
  style: {"height":"300px"}
}
const _hoisted_5 = { colspan: "12" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "dialog-footer" }

import { ref } from "vue";
import SystemService from "../../../system/services/SystemService";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import CreatePromotion from "./CreatePromotion.vue";
import EditPromotion from "./EditPromotion.vue";
import { ElLoading } from "element-plus";


export default /*#__PURE__*/_defineComponent({
  __name: 'PromotionList',
  setup(__props, { expose: __expose }) {

const createPromotionRef = ref<any>(null);
const editPromotionRef = ref<any>(null);
const dialogRef = ref(false);
const isLoading = ref(false);
const data = ref<any>([]);
const promotionId = ref<any>(0);
const promotion = ref<any>({});
const show = (item) => {
  dialogRef.value = true;
  promotion.value = item;
  promotionId.value = item.id;
  fetchData();
};

const showCreatePromotion = (id) => {
  createPromotionRef.value.show(id);
};

const showEditPromotion = (item) => {
  editPromotionRef.value.show(item);
};

const fetchData = async () => {
  isLoading.value = true;
  try {
    const res = await SystemService.queryPromotionList(promotionId.value);
    data.value = res.data;
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};

const duplicatePromotion = async (item) => {
  const loading = ElLoading.service({
    lock: true,
    text: "Loading",
    background: "rgba(0, 0, 0, 0.7)",
  });
  try {
    await SystemService.duplicatePromotionListById(item.id);
    fetchData();
  } catch (error) {
    console.error(error);
  }
  loading.close();
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      modelValue: dialogRef.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogRef).value = $event)),
      width: "800",
      "align-center": "",
      "show-close": false
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(promotion.value.key), 1),
          _createVNode(_component_el_button, {
            type: "success",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showCreatePromotion(promotionId.value))),
            plain: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.create")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (dialogRef.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.close")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("table", _hoisted_3, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.status")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.id")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.startDate")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.endDate")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.updatedOn")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.edit")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.copy")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_4, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_5, [
                    _createVNode(ScaleLoader, { color: '#ffc730' })
                  ])
                ])
              ]))
            : (!isLoading.value && data.value.length == 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, [
                        (item.is_active)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 0,
                              type: "success",
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("status.active")), 1)
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_el_tag, {
                              key: 1,
                              type: "info",
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("status.inactive")), 1)
                              ]),
                              _: 1
                            }))
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.id), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          type: "GMToneLiner",
                          "date-iso-string": item.from
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          type: "GMToneLiner",
                          "date-iso-string": item.to
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          type: "GMToneLiner",
                          "date-iso-string": item.updated_at
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          type: "GMToneLiner",
                          "date-iso-string": item.created_at
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: ($event: any) => (showEditPromotion(item)),
                          plain: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.edit")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_button, {
                          type: "warning",
                          onClick: ($event: any) => (duplicatePromotion(item)),
                          plain: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.copy")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ]))
                  }), 128))
                ]))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(CreatePromotion, {
      ref_key: "createPromotionRef",
      ref: createPromotionRef,
      onSubmit: fetchData
    }, null, 512),
    _createVNode(EditPromotion, {
      ref_key: "editPromotionRef",
      ref: editPromotionRef,
      onSubmit: fetchData
    }, null, 512)
  ], 64))
}
}

})